module.exports = __webpack_public_path__ + "img/4en.221b53e8.png";